// extracted by mini-css-extract-plugin
export default {"wrapper":"Create_wrapper__BlT0x","footer":"Create_footer__oVEBn","hiddenZone":"Create_hiddenZone__NGedJ","visible":"Create_visible__5-Imu","sensors":"Create_sensors__oSpJ1"};